// @ts-nocheck

import React, { useState, useEffect, useCallback } from "react";
import {
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
  Transition,
} from "@headlessui/react";
import { Link } from "react-router-dom";
import { Toaster, toast } from "sonner";
import { UserDetails } from "../../auth/authTypes";
import { useAppDispatch } from "../../../app/hooks";
import CreateBaseLocation from "./CreateBaseLocation";
import {
  fetchCountryList,
  fetchLocationList,
  fetchLocationListStatus,
  updateLocation,
} from "../../location/locationSlice";
import Badge from "../../../components/common/Badge";
import DropDown from "../../../components/common/DropDown";
import { ExclamationIcon, ThreeDotIcon } from "../../../components/icons";

type ChannelProps = {
  userDetails: UserDetails | null;
};

function classNames(...classes: any) {
  return classes.filter(Boolean).join(" ");
}

const roleSearchList = [
  { name: "active" },
  // { name: "deleted" },
  { name: "archived" },
];

const BaseLocation: React.FC<ChannelProps> = React.memo(({}) => {
  const baseIdString =
    localStorage.getItem("UserBaseId") || localStorage.getItem("createBaseId");
  const baseId = baseIdString ? JSON.parse(baseIdString) : null;
  const [searchVal, setSearchVal] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editBoardData, setEditBoardData] = useState<{
    id: number;
    baseId: number;
  } | null>(null);
  const [boardsFetched, setBoardsFetched] = useState<any[]>([]);
  const dispatch = useAppDispatch();
  const [dataLoading, setDataLoading] = useState(false);
  const [countryList, setCountryList] = useState<any[]>([]);
  const [selectSearchRole, setSelectSearchRole] = useState("active");
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [filteredMemberData, setFilteredMemberData] = useState<MemberData[]>(
    [],
  );
  // In Teams component
  useEffect(() => {
    const teamInfoString = localStorage.getItem("baseLocationData");
    if (teamInfoString?.data?.length > 0) {
      const teamInfo = JSON.parse(teamInfoString);
      setBoardsFetched(teamInfo.data);
      setDataLoading(false);
    } else {
      const fetchTeams = async () => {
        setDataLoading(true);
        try {
          const baseResponse = await dispatch(fetchLocationList(baseId));

          if (baseResponse?.payload) {
            setBoardsFetched(baseResponse.payload.data);
            localStorage.setItem(
              "baseLocationData",
              JSON.stringify(baseResponse.payload),
            );
          } else {
            setBoardsFetched([]);
          }
        } catch (error) {
          console.error("Error fetching teams:", error);
          setBoardsFetched([]);
        } finally {
          setDataLoading(false);
        }
      };
      if (baseId) {
        fetchTeams();
      }
    }
  }, [baseId, dispatch]);

  const handleDeleteBoard = useCallback(
    async (id: number, baseId: number) => {
      const payload: createTeamsPayload = {
        status: "deleted",
        id: id,
      };

      try {
        // Update existing team
        const response = await dispatch(
          updateLocation({
            payload,
            userId: baseId,
            id: id,
          }),
        );

        if (response?.payload) {
          // toast.success("Status has been updated successfully");
          toast.success("Location deleted successfully");
          // const updatedBoards = boardsFetched.map((board) =>
          //   board.id === id ? { ...board, status: "deleted" } : board,
          // );
          const updatedBoards = boardsFetched.filter(
            (board) => board.id !== id,
          );
          localStorage.setItem(
            "baseLocationData",
            JSON.stringify({ data: updatedBoards }),
          );

          setBoardsFetched(updatedBoards);

          setIsModalOpen(false);
          setEditBoardData(null);
        } else {
          toast.error("Failed to update status");
        }
      } catch (error) {
        toast.error("An error occurred while updating the status");
        console.error(error);
      }
    },
    [boardsFetched, dispatch],
  );

  const handleArchivedBoard = useCallback(
    async (id: number, baseId: number, status: string) => {
      const payload: createTeamsPayload = {
        status: status,
        id: id,
      };

      try {
        // Update existing team
        const response = await dispatch(
          updateLocation({
            payload,
            userId: baseId,
            id: id,
          }),
        );

        if (response?.payload) {
          toast.success("Status has been updated successfully");
          // Update the local storage and state
          // const updatedBoards = boardsFetched.map((board) =>
          //   board.id === id ? { ...board, status: "archived" } : board,
          // );
          const updatedBoards = boardsFetched.filter(
            (board) => board.id !== id,
          );
          localStorage.setItem(
            "baseLocationData",
            JSON.stringify({ data: updatedBoards }),
          );

          setBoardsFetched(updatedBoards);

          setIsModalOpen(false);
          setEditBoardData(null);
        } else {
          toast.error("Failed to update status");
        }
      } catch (error) {
        toast.error("An error occurred while updating the status");
        console.error(error);
      }
    },
    [boardsFetched, dispatch],
  );

  // Add a new useEffect to handle updates from localStorage
  useEffect(() => {
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === "baseLocationData" && e.newValue) {
        const teamsDataArray = JSON.parse(e.newValue);
        setBoardsFetched(teamsDataArray.data || []);
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  const handleEdit = useCallback(
    (id: number, baseId: number) => {
      const teamToEdit = boardsFetched.find((team) => team.id === id);

      if (teamToEdit) {
        setEditBoardData(teamToEdit);
        setIsModalOpen(true);
      }
    },
    [boardsFetched],
  );

  // Fetch country list when the modal opens
  const openModal = async () => {
    setEditBoardData(null);
    setIsModalOpen(true);

    // try {
    //   const countryResponse = await dispatch(fetchCountryList()).unwrap();
    //   if (countryResponse) {
    //     setCountryList(countryResponse.data);
    //   } else {
    //     console.error("No countries found");
    //     setCountryList([]);
    //   }
    // } catch (error) {
    //   console.error("Error fetching countries:", error);
    //   setCountryList([]);
    // }
  };

  const handleTeamsData = (id: any) => {
    // navigate(`/${baseId}/settings/teams/${id}/detail`);
  };

  const handleSearchRoleChange = (role: string) => {
    setSelectSearchRole(role);
  };

  const handleActive = async () => {
    setLoading1(true);
    try {
      const res = await dispatch(
        fetchLocationListStatus({ baseId, status: "active" }),
      );
      if (res.payload) {
        setBoardsFetched(res.payload.data);
        localStorage.setItem("baseLocationData", JSON.stringify(res.payload));
      } else {
        console.error("No payload received");
      }
    } catch (error) {
      console.error("Delete failed:", error);
      alert("Failed to delete location data. Please try again later.");
    } finally {
      setLoading1(false);
    }
  };

  const handleDelete = async () => {
    setLoading1(true);
    try {
      const res = await dispatch(
        fetchLocationListStatus({ baseId, status: "deleted" }),
      );
      if (res.payload) {
        setBoardsFetched(res.payload.data);
        localStorage.setItem("baseLocationData", JSON.stringify(res.payload));
      } else {
        console.error("No payload received");
      }
    } catch (error) {
      console.error("Delete failed:", error);
      alert("Failed to delete location data. Please try again later.");
    } finally {
      setLoading1(false);
    }
  };

  const handleSuspend = async () => {
    setLoading(true);
    try {
      const res = await dispatch(
        fetchLocationListStatus({ baseId, status: "archived" }),
      );
      if (res.payload) {
        setBoardsFetched(res.payload.data);
        // Update local storage
        localStorage.setItem("baseLocationData", JSON.stringify(res.payload));
      } else {
        console.error("No payload received");
      }
    } catch (error) {
      console.error("Suspend failed:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Toaster richColors />
      <div className="h-full">
        <main className="py-[34px] lg:py-[70px] px-0 lg:px-10 h-auto flex">
          <div className="px-[2px] sm:px-6 lg:px-8 w-full flex justify-center">
            <div className="w-full max-w-[640px]">
              <div className="flex flex-col gap-y-1 w-full">
                <h2 className="text-[20px] lg:text-[24px] font-medium leading-8 text-[#1b1b1b] tracking-[-0.01rem]">
                  Office Locations
                </h2>
                <p className="text-sm leading-5 text-[#5c5c5e] font-medium">
                  Add and manage your office locations. These will be available
                  to associate with job postings.
                </p>
              </div>

              <div className="bg-[#e0e0e0] w-full h-[1px] my-8"></div>
              <div className=" mt-0 lg:mt-0 flex items-center  w-full gap-x-3">
                <div className="w-full lg:w-[40%]">
                  {/* <label htmlFor='searchEmail' className='wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased leading-5'>
                    Base Location
                  </label> */}
                  <div className="mt-[0px]">
                    <input
                      type="text"
                      value={searchVal}
                      onChange={(e) => setSearchVal(e.target.value)}
                      name="search"
                      id="search"
                      placeholder="Search name and email"
                      className="flex w-full grow border px-4 pt-2 pb-[10px] text-sm leading-6 shadow-[0 1px 2px 0 rgba(18, 18, 23, 0.05)] transition-colors duration-100 placeholder:text-surface-500 outline-indigo-600
                      focus:outline focus:outline-2 focus:-outline-offset-1 bg-background text-text-100 hover:border-[#a9a9bc] dark:hover:border-surface-200
                           border-[#e7e7e8] dark:border-surface-100 focus:outline-indigo-600 h-[34px] rounded-[0.375rem]"
                    />
                  </div>
                </div>

                <div className="w-full lg:w-[20%]">
                  <div className="mt-[0px]">
                    <DropDown
                      onChangeValue={handleSearchRoleChange}
                      data={roleSearchList}
                      previousValue={selectSearchRole}
                      onDelete={handleDelete}
                      onArchived={handleSuspend}
                      onActive={handleActive}
                    />
                    {/* <DropDown onChangeValue={(value) => setSelectSearchRole(value)} data={roleSearchList} previousValue={selectSearchRole} /> */}
                  </div>
                </div>
                <div className="w-full lg:w-[40%]">
                  <div className="mt-[0px] flex justify-end">
                    <button
                      onClick={openModal}
                      type="button"
                      className=" inline-flex shrink-0  justify-center rounded-md bg-indigo-600 items-center px-[14px] py-1 text-[13px] font-medium h-[32px] leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    >
                      Create Location
                    </button>
                  </div>
                </div>
              </div>
              <div className="mt-6 w-full">
                <div className="bg-white rounded-lg border border-solid border-[#0009321f]">
                  <div className="font-semibold text-[#1c2024] text-sm  px-[11.4px] py-[11.4px] bg-[#00005506] border-b border-solid border-[#0009321f] last-of-type:border-b-0">
                    Name
                  </div>
                  {dataLoading ? (
                    <div
                      className="flex items-center justify-center relative z-50"
                      style={{ height: "calc(100vh - 391px)" }}
                    >
                      <div className="simple-spinner-loader">
                        <span></span>
                      </div>
                    </div>
                  ) : boardsFetched?.length === 0 ? (
                    <div className="w-full mt-5 flex h-[100px] justify-center items-center flex-col gap-y-3">
                      <ExclamationIcon />
                      <p className="text-[#0000007a] text-[13px]">
                        No results found
                      </p>
                    </div>
                  ) : (
                    <>
                      {boardsFetched
                        ?.filter((post) => {
                          if (searchVal === "") {
                            return post;
                          } else if (
                            post?.location_name
                              ?.toLowerCase()
                              .includes(searchVal.toLowerCase())
                          ) {
                            return post;
                          }
                        })
                        .map((items: any, index: number) => {
                          return (
                            <div
                              key={index}
                              className="w-full flex border-b border-[#0009321f] last-of-type:border-none"
                            >
                              <ul className="list-none w-full">
                                <li className="flex flex-row items-center justify-between text-[0.875rem] px-[11.4px] py-[11.4px] w-full">
                                  <div className="flex shrink-0 pr-0">
                                    {/* <span
                                    className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full border-none text-[0.625rem] font-medium text-white capitalize"
                                    style={{ backgroundColor: items?.color }}
                                  >
                                    {items.name[0]}
                                  </span> */}
                                  </div>
                                  <div
                                    className="flex-1 pr-4"
                                    onClick={() => handleTeamsData(items?.id)}
                                  >
                                    <span className="text-[0.8125rem] font-semibold leading-5 text-[#1b1b1b]">
                                      {items?.location_name}
                                    </span>
                                    <div className="flex items-center gap-x-1">
                                      {items?.location_address && (
                                        <span className=" flex text-xs text-[12px] leading-4 text-[#5c5c5e]">
                                          {items?.location_address},
                                        </span>
                                      )}
                                      {items?.location_city && (
                                        <span className=" flex text-xs text-[12px] leading-4 text-[#5c5c5e]">
                                          {items?.location_city},
                                        </span>
                                      )}
                                      {items?.location_state && (
                                        <span className=" flex text-xs text-[12px] leading-4 text-[#5c5c5e]">
                                          {items?.location_state},
                                        </span>
                                      )}
                                      {items?.location_country && (
                                        <span className=" flex text-xs text-[12px] leading-4 text-[#5c5c5e]">
                                          {items?.location_country},
                                        </span>
                                      )}
                                      {items?.location_pincode && (
                                        <span className=" flex text-xs text-[12px] leading-4 text-[#5c5c5e]">
                                          {items?.location_pincode}
                                        </span>
                                      )}
                                      {items?.emoji && (
                                        <span className=" flex text-xs text-[12px] leading-4 text-[#5c5c5e]">
                                          {items?.emoji}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                  <div>
                                    <Badge status={items?.status} />
                                  </div>
                                  <div className="px-2 flex items-center">
                                    <Menu
                                      as="div"
                                      className="relative inline-block text-left"
                                    >
                                      <div>
                                        <MenuButton className="rounded-md flex items-center justify-center hover:bg-light-gray-200 focus:bg-light-gray-200 w-[32px] h-[32px]">
                                          <span className="sr-only">
                                            Open options
                                          </span>
                                          <ThreeDotIcon />
                                        </MenuButton>
                                      </div>

                                      <Transition
                                        enter="transition ease-out duration-100"
                                        enterFrom="transform opacity-0 scale-95"
                                        enterTo="transform opacity-100 scale-100"
                                        leave="transition ease-in duration-75"
                                        leaveFrom="transform opacity-100 scale-100"
                                        leaveTo="transform opacity-0 scale-95"
                                      >
                                        <MenuItems
                                          className="absolute z-10 mt-[9px] left-[0px] bg-white max-w-[108px] min-w-[108px] w-full overflow-hidden rounded-lg border border-border
                                 bg-popover p-1 text-popover-foreground shadow-lg shadow-black/5 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 
                                 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2
                                  data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2"
                                        >
                                          <div className="py-1">
                                            <MenuItem>
                                              {({ focus }) => (
                                                <div
                                                  onClick={() =>
                                                    handleEdit(
                                                      items.id,
                                                      items.base_id,
                                                    )
                                                  }
                                                  className={classNames(
                                                    focus
                                                      ? "bg-gray-100 text-gray-900"
                                                      : "text-gray-700",
                                                    "relative flex cursor-default select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0",
                                                  )}
                                                >
                                                  Edit
                                                </div>
                                              )}
                                            </MenuItem>
                                            <MenuItem>
                                              {({ focus }) => (
                                                <Link
                                                  to="#"
                                                  className={classNames(
                                                    focus
                                                      ? "bg-gray-100 text-gray-900"
                                                      : "text-gray-700",
                                                    "relative flex cursor-default select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0",
                                                  )}
                                                  onClick={() =>
                                                    handleDeleteBoard(
                                                      items.id,
                                                      items.base_id,
                                                    )
                                                  }
                                                >
                                                  Delete
                                                </Link>
                                              )}
                                            </MenuItem>
                                            {selectSearchRole === "active" && (
                                              <MenuItem>
                                                {({ focus }) => (
                                                  <Link
                                                    to="#"
                                                    onClick={() =>
                                                      handleArchivedBoard(
                                                        items.id,
                                                        items.base_id,
                                                        "archived",
                                                      )
                                                    }
                                                    className={classNames(
                                                      focus
                                                        ? "bg-gray-100 text-gray-900"
                                                        : "text-gray-700",
                                                      "relative flex cursor-default select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0",
                                                    )}
                                                  >
                                                    Archived
                                                  </Link>
                                                )}
                                              </MenuItem>
                                            )}
                                            {selectSearchRole ===
                                              "archived" && (
                                              <MenuItem>
                                                {({ focus }) => (
                                                  <Link
                                                    to="#"
                                                    onClick={() =>
                                                      handleArchivedBoard(
                                                        items.id,
                                                        items.base_id,
                                                        "active",
                                                      )
                                                    }
                                                    className={classNames(
                                                      focus
                                                        ? "bg-gray-100 text-gray-900"
                                                        : "text-gray-700",
                                                      "relative flex cursor-default select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0",
                                                    )}
                                                  >
                                                    Active
                                                  </Link>
                                                )}
                                              </MenuItem>
                                            )}
                                          </div>
                                        </MenuItems>
                                      </Transition>
                                    </Menu>
                                  </div>
                                </li>
                              </ul>
                            </div>
                          );
                        })}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>

      <CreateBaseLocation
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        editBoardData={editBoardData}
        baseId={baseId}
        setEditBoardData={setEditBoardData}
        countryList={countryList}
        setCountry={setCountryList}
      />
    </>
  );
});
export default BaseLocation;
